export default __webpack_public_path__ + "static/media/md-card-bg-dm.2ef0c3ea.png";